module.exports = __webpack_public_path__ + "img/ammiraglio 5.18781155.jpeg";